import dayjs from 'dayjs'
import { INSIGHT_DESCRIPTIONS, INSIGHT_METRICS, INSIGHT_OTHER_LABELS, INSIGHT_TOLERANCE } from '#/containers/PropertyDetail/components/Valuations/consts'
import InsightCard from '../InsightCard'
import { Carousel } from '../common'
import { LOT_DETAILS_DESCRIPTIONS, LOT_DETAILS_METRICS, LOT_DETAILS_OTHER_LABELS, LOT_DETAILS_TOLERANCE, NEARBY_STATISTICS_DESCRIPTIONS, NEARBY_STATISTICS_METRICS, NEARBY_STATISTICS_OTHER_LABELS, NEARBY_STATISTICS_TOLERANCE } from './consts'
import InsightsGroup from '.'

type InsightsProps = {
  className?: string
  property: TopHap.ExtendedProperty
}

const Insights: React.FC<InsightsProps> = ({ className, property }) => (
  <Carousel className={className}>
    <InsightsGroup
      description={INSIGHT_DESCRIPTIONS}
      metrics={INSIGHT_METRICS}
      otherLabel={INSIGHT_OTHER_LABELS}
      property={property}
      tolerance={INSIGHT_TOLERANCE}
    />
    <InsightsGroup
      description={LOT_DETAILS_DESCRIPTIONS}
      metrics={LOT_DETAILS_METRICS}
      otherLabel={LOT_DETAILS_OTHER_LABELS}
      property={property}
      tolerance={LOT_DETAILS_TOLERANCE}
    />
    <InsightsGroup
      description={NEARBY_STATISTICS_DESCRIPTIONS}
      metrics={NEARBY_STATISTICS_METRICS}
      otherLabel={NEARBY_STATISTICS_OTHER_LABELS}
      property={property}
      tolerance={NEARBY_STATISTICS_TOLERANCE}
    >
      {/* {property.age !== null &&
        property.age <= 1 && */}
      {property.YearBuilt !== null &&
        dayjs(property.YearBuilt).year() === dayjs().year() &&
        property.PropertyUseGroup !== 'Land' && (
        <InsightCard
          description='Built less than 1 year ago.'
          title='New Construction'
        />
      )}
    </InsightsGroup>
  </Carousel>
)

export default Insights
